export class CancelEvent {
  private _isCanceled = false;

  public get isCanceled() {
    return this._isCanceled;
  }

  public cancel() {
    this._isCanceled = true;
  }
}

export enum CacheEntryPriority {
  NORMAL,
  NEVER_REMOVE,
}

export class CacheEntryExpiringEvent extends CancelEvent {
  private _key: any;

  constructor(key: any) {
    super();
    this._key = key;
  }

  public get key() {
    return this._key;
  }
}

export type CacheEntryExpiredEvent = {
  key: any;
};
